import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackButtonDirective } from './directives/back-button.directive';
import { RerenderDirective } from './directives/rerender.directive';
import { BypassUrlSafetyPipe } from './pipes/bypass-url-security.pipe';
import { ClickableTelephoneNumberPipe } from './pipes/clickable-telephone-number.pipe';
import { EmailLinkPipe } from './pipes/email-link.pipe';
import { ListFormatPipe } from './pipes/list-format.pipe';
import { PreventNegativePipe } from './pipes/prevent-negative.pipe';
import { ReplaceTextPipe } from './pipes/replace-text.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    BackButtonDirective,
    ClickableTelephoneNumberPipe,
    EmailLinkPipe,
    ListFormatPipe,
    PreventNegativePipe,
    ReplaceTextPipe,
    RerenderDirective,
    BypassUrlSafetyPipe,
    SanitizeHtmlPipe,
  ],
  exports: [
    BackButtonDirective,
    ClickableTelephoneNumberPipe,
    EmailLinkPipe,
    ListFormatPipe,
    PreventNegativePipe,
    ReplaceTextPipe,
    RerenderDirective,
    BypassUrlSafetyPipe,
    SanitizeHtmlPipe,
  ],
})
export class UtilsModule {}
